import { getCurrentBasic } from './core/ProgramService'

/**
 *
 * @description 节目 - 浏览
 */
export async function reportProgramView(params: {
    scheduleId: string
    scheduleName: string

    programId: string
    programName: string
    
    topicId: string
    topicTitle: string
}) {
    window['sensors'].track(
        'KbPGCObjUserAct',
        Object.assign(await getCurrentBasic(), {
            business: 'PROGRAM',
            businessVer: 1,
            pageName: '节目互动详情页',
            pageUrl: window.location.href,

            ref1Name: '节目互动排班',
            ref1: params.scheduleId,
            ref1Title: params.scheduleName,

            ref2Name: '广播节目',
            ref2: params.programId,
            ref2Title: params.programName,

            ref3Name: '节目话题',
            ref3: params.topicId,
            ref3Title: params.topicTitle,

            view: 1,
        }),
    )
}
